<template>
    <div v-bind:class="'alert-'+alertMessage.alert_context" class="alert alert-block alert ">

        <span class="fa fa-times-circle fa-2x close-btn"
              @click="$emit('setAlertAsClosed')"
              v-if="!alertMessage.is_confirmation_needed">
        </span>

        <Spinner v-bind:title="'Sending Alert ...'" v-if="isSaving" ></Spinner>

        <strong @click="$emit('openAlert')" class="title-message-open-alert" v-show="!isSaving" >
            {{ alertMessage.message }}
            <template v-if="alertMessage.isConfirmationMessageOpen ">
                <i class="fa fa-times pull-right  "></i>
            </template>
            <template v-else>
                <i class="fa fa-envelope pull-right  "></i>
            </template>
        </strong>

        <div class="confirmation_message " v-show="alertMessage.isConfirmationMessageOpen && !isSaving " >

            <p v-if="alertMessage.document">
                {{'The quote of client'|trans }} <strong>{{ alertMessage.document.job.customer.lastname }}</strong> {{'has been accepted'|trans}}<br>
                <br>
                <a v-bind:href="generateLinkForPdf(alertMessage.document.id)" class="btn btn-primary" target="_blank">{{'Show Document'|trans}}</a>
            </p>

            <!-- JOB PURE CONTACT -->
            <div class="">

                <div v-if="alertMessage.document.job.is_pure_contact">

                    <strong>{{'Did you receive the down payment?'|trans}}</strong>
                    <select v-model="devis.isPaymentReceived" class="form-control">
                        <option v-bind:value="null">{{'Please select an option'|trans}}</option>
                        <option v-bind:value="true">{{'Yes'|trans}}</option>
                        <option v-bind:value="false">{{'Non'|trans}}</option>
                    </select>

                    <div v-if="devis.isPaymentReceived === false" class="">
                        <br>
                        {{'You can wait 1 or 2 days, or then contact the customer at '|trans }}
                        <br>
                        <!--[] Snooze task worker_task() -->
                        <button @click="$emit('snoozeAlert', defaultSnoozeHours)" class="btn btn-primary" v-bind:disabled="isSnoozedTimerEnable">{{'Reminder in 2h'|trans}}</button>
                        &nbsp;
                        <button @click="cancelDevis" class="btn btn-primary ">{{'the customer does not want anymore'|trans}}</button>
                        <!--pas d'interaction mais il faut rajouter history log dans le document current-->
                    </div>
                </div>

                <div v-else>
                    <strong>{{'The deposit has been received.'|trans}}</strong>
                </div>

                <div v-if="devis.isPaymentReceived" class="">
                    {{'How many hours will it be necessary to block for this work'|trans}}
                    <select v-model="devis.hoursToSchedule" class="form-control">
                        <option v-bind:value="'1h'">1{{'h'|trans}}</option>
                        <option v-bind:value="'2h'">2{{'h'|trans}}</option>
                        <option v-bind:value="'3h'">3{{'h'|trans}}</option>
                        <option v-bind:value="'4h'">4{{'h'|trans}}</option>
                        <option v-bind:value="'6h'">6{{'h'|trans}}</option>
                        <option v-bind:value="'8h'">8{{'h'|trans}}</option>
                        <option v-bind:value="'12h'">12{{'h'|trans}}</option>

                        <option v-bind:value="'2days'">2{{'days'|trans}}</option>
                        <option v-bind:value="'3days'">3{{'days'|trans}}</option>
                        <option v-bind:value="'4days'">4{{'days'|trans}}</option>
                        <option v-bind:value="'5days'">5{{'days'|trans}}</option>
                    </select>

                    {{'When can you have the parts ?'|trans}}
                    <DatePicker v-model="devis.dateOfWhenWorkerCanHaveParts"
                                wrapper-class="form-group date-picker-control"
                                input-class="form-control"
                                format="yyyy-MM-dd"
                                :disabled-dates="disallowThePastDates"
                                :highlighted="currentDate"
                                :monday-first="true"
                    ></DatePicker>
                </div>
            </div>

            <div v-show="alertMessage.document.job.is_pure_contact === false || devis.isPaymentReceived !== null">
                <label v-bind:for="'note'">{{'Note'|trans}}</label>
                <textarea v-model="devis.confirmationMessage" class="form-control" id="note"> </textarea>
                <p>{{'Please write at least'|trans}} {{ minimumCharacters }} {{ 'chars'|trans}}</p>
                <button class="btn btn-primary" @click="submitConfirmation()" v-bind:disabled="!isEnabled">Submit</button>
                <button class="btn btn-primary f-right" @click="$emit('snoozeAlert', defaultSnoozeHours)" v-bind:disabled="isSnoozedTimerEnable">{{'Reminder in 2h'|trans}}</button>
            </div>

        </div>
    </div>

</template>

<script>
    import Routing from '../../../backend-router';
    import Spinner from '../../Spinner';
    import DatePicker from 'vuejs-datepicker';
    import moment from 'moment';

    export default {
        props: {
            alertMessage : Object,
            isSnoozedTimerEnable : false
        },
        data(){
            return {
                defaultSnoozeHours:2,
                minimumCharacters : 15,
                isSaving: false,
                devis : {
                    isPaymentReceived : null,
                    hoursToSchedule : '',
                    dateOfWhenWorkerCanHaveParts : null,
                    confirmationMessage : ''
                }
            }
        },
        created(){
          if(this.alertMessage.document.job.is_pure_contact===false){
              this.devis.isPaymentReceived = true;
          }
        },
        methods: {
            generateLinkForPdf(documentId){
                return  process.env.VUE_APP_API_BASE_URL + Routing.generate('worker_interface_generate_pdf', {id: documentId, action : 'generate'});
            },
            async submitConfirmation() {
                this.isSaving = true;
                this.alertMessage.devis = this.devis;
                await this.$api.alert.responseAlertDevis(this.alertMessage);
                this.$emit('hideAlert');
                this.isSaving = false;
            },
            async cancelDevis(){
                this.isSaving = true;
                this.alertMessage.devis = this.devis;
                await this.$api.alert.cancelDevis(this.alertMessage);
                this.$emit('hideAlert');
                this.isSaving = false;
            }
        },
        computed : {
            isEnabled(){
                return (this.devis .confirmationMessage.length > this.minimumCharacters)
            },
            disallowThePastDates(){
                return {
                    to: moment().subtract(1, "days").toDate()
                };
            },
            currentDate(){
                return {to: new Date(), from:new Date()}
            }
        },
        components: {
            Spinner,
            DatePicker
        }
    }
</script>

<style scoped>
    .f-right{
        float: right;
    }
    .close-btn{
        position:absolute;
        right:-7px;
        top:-7px;
    }
</style>